import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PRODUCT_QUERY_KEY } from './useGetProduct';
import { GET_PRODUCTS_QUERY_KEY } from './useGetProducts';

import ProductsService, {
  Product,
  UpdateProductAttributeDto,
} from '@/services/ProductsService';

export function useUpdateProductAttribute(productId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (updateProductAttributeDto: UpdateProductAttributeDto) =>
      ProductsService.updateProductAttribute(
        productId,
        updateProductAttributeDto,
      ),
    onSuccess: (data) => {
      queryClient.setQueryData<Product>(GET_PRODUCT_QUERY_KEY(productId), data);

      queryClient.invalidateQueries({
        queryKey: GET_PRODUCTS_QUERY_KEY(),
      });
    },
  });

  return {
    updateProductAttribute: mutateAsync,
    isLoading: isPending,
  };
}
